/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';


const serializableError = (err) =>
  err?.response ? { status: err.response.status, message: err.response?.data?.message || 'Request failed' } : { status: 500, message: 'Network error' };

// Get All Customers (GET)
export const getAllCustomers = createAsyncThunk('get All Customers', async () => {
  try {
    const res = await $axios.get('/users/customers');
    return [res.data.data, null];
  } catch (err) {
    return [null, serializableError(err)];
  }
});

// Single Customer (GET) - admin fetches by user ID
export const getSingleCustomer = createAsyncThunk('get Single Customer', async (userId) => {
  try {
    const res = await $axios.get(`/users/${userId}`);
    return [res.data.data, null];
  } catch (err) {
    return [null, serializableError(err)];
  }
});

// Update Customer (PATCH)
export const updateCustomer = createAsyncThunk('update Customer', async ({ userId, data }) => {
  try {
    const res = await $axios.patch(`/users/${userId}`, data);
    return [res.data.data, null];
  } catch (err) {
    return [null, serializableError(err)];
  }
});

// Block/Unblock Customer (PATCH)
export const blockCustomer = createAsyncThunk('block Customer', async ({ userId, isBlocked }) => {
  try {
    const res = await $axios.patch(`/users/${userId}`, { isBlocked });
    return [res.data.data, null];
  } catch (err) {
    return [null, serializableError(err)];
  }
});

// Get orders by user (admin)
export const getOrdersByUser = createAsyncThunk('get Orders By User', async ({ userId, page = 1, limit = 20 }) => {
  try {
    const res = await $axios.get(`/orders/admin/by-user/${userId}?page=${page}&limit=${limit}`);
    return [res.data, null];
  } catch (err) {
    return [null, serializableError(err)];
  }
});

// Slice
const customerSlice = createSlice({
  name: 'customerSlice',
  initialState: {
    allCustomers: [],
    singleCustomer: null,
    singleCustomerError: null,
    customerOrders: [],
    customerOrdersTotal: 0,
    customerOrdersError: null,
  },
  reducers: {
    clearSingleCustomer: (state) => {
      state.singleCustomer = null;
      state.singleCustomerError = null;
      state.customerOrders = [];
      state.customerOrdersTotal = 0;
      state.customerOrdersError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomers.pending, (state) => {
        state.allCustomers = [];
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        const [resp, err] = action.payload;
        state.allCustomers = resp || [];
      })
      .addCase(getSingleCustomer.pending, (state) => {
        state.singleCustomerError = null;
      })
      .addCase(getSingleCustomer.fulfilled, (state, action) => {
        const [resp, err] = action.payload;
        state.singleCustomer = resp || null;
        state.singleCustomerError = err;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        const [resp, err] = action.payload;
        if (resp) state.singleCustomer = resp;
      })
      .addCase(blockCustomer.fulfilled, (state, action) => {
        const [resp, err] = action.payload;
        if (resp) state.singleCustomer = resp;
      })
      .addCase(getOrdersByUser.pending, (state) => {
        state.customerOrdersError = null;
      })
      .addCase(getOrdersByUser.fulfilled, (state, action) => {
        const [resp, err] = action.payload;
        if (resp?.data) {
          state.customerOrders = resp.data;
          state.customerOrdersTotal = resp.total ?? 0;
        } else {
          state.customerOrders = [];
          state.customerOrdersTotal = 0;
        }
        state.customerOrdersError = err;
      });
  },
});

export const { clearSingleCustomer } = customerSlice.actions;
export default customerSlice.reducer;
